<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
  class="flex h-screen bg-age-cream font-[Segoe_UI,sans-serif] overflow-hidden"
>
  <!-- Backdrop for mobile/tablet -->
  @if (isSidebarOpen()) {
  <div
    (click)="toggleSidebar()"
    class="fixed inset-0 z-20 bg-black/20 backdrop-blur-sm lg:hidden"
  ></div>
  }

  <!-- Sidebar -->
  <aside
    [class.translate-x-0]="isSidebarOpen()"
    [class.-translate-x-full]="!isSidebarOpen()"
    class="fixed inset-y-0 left-0 z-30 w-64 bg-white border-r border-age-beige transition-transform duration-300 ease-in-out lg:relative lg:translate-x-0 shrink-0 flex flex-col"
  >
    <div class="px-6 pt-6 pb-8 flex items-center justify-between">
      <img src="logo.png" alt="AGE Logo" class="h-12 w-auto" />
      <button (click)="toggleSidebar()" class="lg:hidden p-2 text-age-primary">
        <svg
          class="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <nav class="flex-1 px-3 space-y-1">
      @if(isAdmin()){
      <a
        routerLink="/dashboard"
        routerLinkActive="bg-age-green text-white"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="isSidebarOpen() && toggleSidebar()"
        class="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-age-primary transition-colors hover:bg-age-green hover:text-white"
      >
        <svg
          class="w-5 h-5 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
        Tableau de bord
      </a>
      }

      <a
        routerLink="/registrations"
        routerLinkActive="bg-age-green text-white"
        (click)="isSidebarOpen() && toggleSidebar()"
        class="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-age-primary transition-colors hover:bg-age-green hover:text-white"
      >
        <svg
          class="w-5 h-5 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2"
          />
          <path d="M9 4h6v2H9V4z" />
        </svg>
        Inscriptions
      </a>

      <a
        routerLink="/participants"
        routerLinkActive="bg-age-green text-white"
        (click)="isSidebarOpen() && toggleSidebar()"
        class="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-age-primary transition-colors hover:bg-age-green hover:text-white"
      >
        <svg
          class="w-5 h-5 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
        Participants
      </a>
    </nav>

    <div class="px-3 pb-6">
      <button
        (click)="logout()"
        class="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm font-medium text-age-primary transition-colors hover:bg-red-50 hover:text-red-600"
      >
        <svg
          class="w-5 h-5 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
          />
        </svg>
        Déconnexion
      </button>
    </div>
  </aside>

  <!-- Main -->
  <div class="flex-1 flex flex-col overflow-hidden w-full">
    <!-- Topbar -->
    <header
      class="flex items-center justify-between px-4 lg:px-8 py-4 bg-white shrink-0 border-b border-age-beige"
    >
      <div class="flex items-center gap-4">
        <button
          (click)="toggleSidebar()"
          class="lg:hidden p-2 text-age-primary"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h1
          class="font-bebas text-xl lg:text-2xl tracking-widest text-age-green leading-none truncate"
        >
          {{ titleService.title() }}
        </h1>
      </div>

      <div class="flex items-center gap-2 lg:gap-3">
        <div class="text-right hidden sm:block">
          <p class="text-sm font-semibold text-age-brown leading-tight">
            {{ fullName }}
          </p>
          <p class="text-xs text-age-primary">{{ userRole() }}</p>
        </div>
        <div
          class="w-9 h-9 rounded-full bg-age-brown flex items-center justify-center text-white text-sm font-bold shrink-0"
        >
          {{ nameInitials() }}
        </div>
      </div>
    </header>

    <!-- Scrollable area -->
    <div class="flex-1 overflow-y-auto flex flex-col">
      <main class="flex-1 px-4 lg:px-8 py-6">
        <router-outlet />
      </main>

      <footer class="bg-age-footer px-4 lg:px-8 py-6 text-center mt-auto">
        <p
          class="text-[10px] lg:text-xs font-bebas tracking-widest text-age-brown"
        >
          16ÈME RENCONTRES NATIONALES DE GÉRONTOLOGIE
        </p>
        <p class="text-[10px] lg:text-xs text-age-primary mt-1">
          Du jeudi 21 au samedi 23 mai 2026 • Casablanca, Maroc
        </p>
        <p class="text-[10px] lg:text-xs text-age-primary mt-1">
          © 2026 1of1Events. Tous droits réservés.
        </p>
      </footer>
    </div>
  </div>
</div>
